<template>
    <div class="cocurrentAndConvection">
        <div class="tb-head-btn">
            <!-- <div class="btn-left">
                <el-button class="bigData-btn-cocurrentAndConvection-tldl" type="primary" @click="flowHandle" :loading="loading" :disabled="disabled" v-has="'02010079'">对流供应商推荐</el-button>
                <div class="checkbox">
                    <el-checkbox v-model="isCheckedLine" disabled>按线路</el-checkbox>
                    <el-checkbox v-model="isCheckedCarType">按车型</el-checkbox>
                    <el-select v-model="selectedCarType" multiple collapse-tags filterable placeholder="主要车型" style="margin-left: 30px;width: 250px;" v-if="isCheckedCarType">
                        <el-option v-for="(v, i) in carTypeOptions" :key="i" :label="v.label" :value="v.value"></el-option>
                    </el-select>
                </div>
            </div> -->
            <div>
                <el-input v-model="query.supplierCode" placeholder="供应商编码" clearable />
                <el-input v-model="query.supplierNameLike" placeholder="供应商名称" clearable></el-input>
                <el-button class="bigData-btn-cocurrentAndConvection-search" type="primary" @click="handleSearch" :loading="tableLoading">查询</el-button>
                <el-button class="bigData-btn-cocurrentAndConvection-mail" type="primary" @click="emailNoticeHandle" :loading="emailBtnLoading" :disabled="disabled" v-has="'02010080'">邮箱推荐</el-button>
                <el-button class="bigData-btn-cocurrentAndConvection-message" type="primary" @click="messageNoticeHandle" :loading="messageBtnLoading" :disabled="disabled" v-has="'02010081'">
                    短信推荐</el-button>
            </div>
            <div><el-button class="bigData-btn-cocurrentAndConvection-export" type="primary" @click="exportHandle" :loading="exportBtnLoading"><i class="el-icon-upload2"></i>导出</el-button></div>
        </div>
        <!-- 表格 -->
        <div class="cocurrentAndConvection-tb">
            <m-pane
            ref="cocurrentAndConvectionTable"
            :config="config"
            :currentPage="query.pageNo"
            :totalData="tableData"
            :pageTotal="totalCount"
            :loading="tableLoading"
            @edit-btn="handleEdit"
            @rank-btn="handleRank"
            @pageChange="pageChange"
            @sizeChange="sizeChange"
            ></m-pane>
        </div>
        <PortraitDetailDialog ref="potDtRef" />
        <SupRecommendDialog ref="supRec" @save="getTableData"></SupRecommendDialog>
    </div>
</template>
<script>
import mPane from '../../../components/Panel.vue';
import { mapState } from 'vuex';
import config from './cocurrentAndConvectionConfig.js';
import { getLineDivisionList, recommendSendEmail, recommendSendMessage, exportLineDivision } from '../../../api/supplierBid.js';
import { queryPortrait } from '../../../api/transportPortrait.js';
import { dictWithUrl } from '@/components/lots/api';
import { SRM_YES, SRM_NO, TRANSPORTATION_NUM } from '../../../constant/constant.js';
import { BID_STATUS } from '../roundQuote/constant.js';
import PortraitDetailDialog from '../../resource/transportPortrait/PortraitDetailDialog.vue';
import SupRecommendDialog from './SupRecommendDialog.vue';

// 类型 BID_LINE_DIVISION_MATCH_TYPE
const MT_CITY = '2';
const MT_PROVINCE = '3';

export default {
    components: { mPane, PortraitDetailDialog, SupRecommendDialog },
    data() {
        return {
            config,
            tableData: [], // 表格数据
            totalCount: 0, // 表格总条数
            tableLoading: false, // 表格加载
            // loading: false, // 同流对流按钮加载
            emailBtnLoading: false, // 邮箱推荐按钮加载
            messageBtnLoading: false, // 短信推荐按钮加载
            exportBtnLoading: false, // 导出按钮加载
            // isCheckedLine: true, // 按线路
            // isCheckedCarType: false, // 按车型
            // selectedCarType: [], // 选中的主要车型
            // carTypeOptions: [], // 主要车型列表
            dict: {}, // 字典数据
            query: {
                supplierCode: '',
                supplierNameLike: '',
                pageNo: 1,
                pageSize: 10
            },
            exportParams: {
                tabType:"1",// "tabType": "0" 就是储备页签，"tabType": "1"就是同流对流页签
                bidNo: this.$route.query.bidNo,
                tenantCode: this.$store.state.currentTenant.tenantCode,
            }
        };
    },
    // watch: {
    //     isCheckedCarType(newVal) {
    //         this.selectedCarType = [];
    //     }
    // },
    computed: mapState({
        disabled(state) { // 【标书通过、标书驳回、标书待审】这三种状态下允许操作
            return [BID_STATUS.BIDPASS, BID_STATUS.BIDREJECT, BID_STATUS.BIDPENDING].indexOf(state.bidData.bidStatus) < 0;
        }
    }),
    async mounted() {
        await this.getDictionaryData();
        // this.carTypeOptions = this.mapCarTypeOptions();
        this.getTableData();
    },
    methods: {
        /**
         * @description: 获取字典数据
         * @augments: SRM_SHIPPER_TYPE: 承运商类别  TMS_VEHICLE_BIG_TYPE: 主要车型
         */
        getDictionaryData() {
            return dictWithUrl('SRM_SHIPPER_TYPE').then(res => {
                if (res && +res.code === 0) {
                    this.dict = res.data || {};
                }
            });
        },
        /**
         * @description: 获取表格数据
         * @augments: bidNo: 招标编码  carTypeList: 主要车型
         */
        getTableData() {
            this.tableLoading = true;
            getLineDivisionList({
                tabType:"1",
                bidNo: this.$route.query.bidNo,
                // carTypeList: this.selectedCarType,
                ...this.query
            }).then(res => {
                if (res && +res.code === 0) {
                    this.totalCount = res.data.totalCount || 0;
                    this.tableData = this.dealWith(res.data.list || []);
                }
            }).finally(() => {
                // this.loading = false;
                this.tableLoading = false;
            });
        },
        handleSearch() {
            this.exportParams.supplierCode = this.query.supplierCode
            this.exportParams.supplierNameLike = this.query.supplierNameLike
            this.query.pageNo = 1;
            this.getTableData();
        },
        // 响应参数处理
        dealWith(array) {
            array.forEach(v => {
                v.transTypeText = this.dict.SRM_SHIPPER_TYPE[v.transType];
                v.hiddenEvent = v.matchType && [+MT_CITY, +MT_PROVINCE].includes(+v.matchType) ? ['edit'] : [];
            });
            return array;
        },
        // // 映射主要车型键值对
        // mapCarTypeOptions() {
        //     return Object.entries(this.dict.TMS_VEHICLE_BIG_TYPE).map(item => {
        //         return {
        //             label: item[1],
        //             value: item[0]
        //         };
        //     });
        // },
        // 同流对流
        flowHandle() {
            // if (this.isCheckedCarType && this.selectedCarType.length === 0) {
            //     return this.$message.warning('请选择主要车型！');
            // }
            this.query.pageNo = 1;
            // this.loading = true;
            this.getTableData();
        },
        /**
         * @description: 邮箱推荐【发送邮件】
         * @augments: bidNo: 招标编码  carTypeList: 主要车型
         */
        emailNoticeHandle() {
            this.emailBtnLoading = true;
            recommendSendEmail({
                tabType:"1",// "tabType": "0" 就是储备页签，"tabType": "1"就是同流对流页签
                bidNo: this.$route.query.bidNo, // 招标编码
                // carTypeList: this.selectedCarType // 主要车型
            }).then(res => {
                if (res && +res.code === 0) {
                    this.$message.success('邮件发送成功，请注意查看');
                    this.getTableData();
                }
            }).finally(() => {
                this.emailBtnLoading = false;
            });
        },
        /**
         * @description: 短信推荐【发送短信】
         * @augments: bidNo: 招标编码  carTypeList: 主要车型
         */
        messageNoticeHandle() {
            this.messageBtnLoading = true;
            recommendSendMessage({
                tabType:"1",// "tabType": "0" 就是储备页签，"tabType": "1"就是同流对流页签
                bidNo: this.$route.query.bidNo, // 招标编码
                // carTypeList: this.selectedCarType // 主要车型
            }).then(res => {
                if (res && +res.code === 0) {
                    this.$message.success('短信发送成功，请注意查看');
                    this.getTableData();
                }
            }).finally(() => {
                this.messageBtnLoading = false;
            });
        },
        // 切换分页显示条数
        sizeChange(pageSize) {
            this.query.pageNo = 1;
            this.query.pageSize = pageSize;
            this.getTableData();
        },
        // 切换当前分页
        pageChange(pageNo) {
            this.query.pageNo = pageNo;
            this.getTableData();
        },
        handleEdit(row) {
            this.$refs.supRec.open(row)
        },
        handleRank(row) {
            this.tableLoading = true;
            queryPortrait({ supplierCode: row.supplierCode, businessTypeList: [TRANSPORTATION_NUM] }).then(res => {
                if (res && +res.code === 0) {
                    if (res.data.list.length) {
                        this.$refs.potDtRef.open(res.data.list[0]);
                    } else {
                        this.$message.warning('暂无该供应商评级数据!');
                    }
                }
            }).finally(() => { this.tableLoading = false; })
        },
        exportHandle() {
            this.exportBtnLoading = true;
            exportLineDivision(this.exportParams).then(res => {
                if (res && +res.code === 0) {
                    this.$message.success(res.data || '文件处理中，稍后请留意右上角文件中心下载文件！')
                }
            }).catch(err => {}).finally(() => {
                this.exportBtnLoading = false;
            });
        },
    }
};
</script>
<style lang="less">
.cocurrentAndConvection {
    .tb-head-btn {
        display: flex;
        justify-content: space-between;
        align-items: center;
        // flex-direction: row-reverse;
        margin-bottom: 15px;

        .el-input {
            margin-right: 10px;
            width: 160px;
        }

        .btn-left {
            display: flex;
            align-items: center;

            .checkbox {
                margin-left: 30px;
            }
        }
    }

    .el-icon-upload2{
        padding-right: 3px;
    }

    #mPane3 .el-table {
        min-height: calc(100vh - 344px);
        max-height: calc(100vh - 344px);
    }
}
.cocurrentAndConvection .cocurrentAndConvection-tb .model-table-search { display: none; }
</style>